import React,{useState, useEffect} from "react";
import sendicon from './../../../images/sendmoneyicon.png'
import receiveicon from './../../../images/receivemoneyicon.png'
import receivepaymenticon from './../../../images/receivepaymenticon.png'
import sendpaymenticon from './../../../images/sendpaymenticon.png'
import banktransfericon from './../../../images/banktransfericon.png'
import paymentinfoicon from './../../../images/paymentinfobtn.png'
import walletgraph from './../../../images/walletbars.png'
import walletcomingsoon from './../../../images/walletcomingsoon.png'
import moreoptionsbtn from './../../../images/moreoptionbtn.png'
import Statements from "./../../PostLogin/Dashboard/Wallet/Statements";
import Wallet from "./../../PostLogin/Dashboard/Wallet/Wallet";
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import {Route,Routes, Redirect, Navigate} from 'react-router-dom'
import {useLocation,useNavigate} from "react-router-dom";
import { useJwt, decodeToken } from "react-jwt";
import Royalties from './Royalties'
 
function Accounting({nav,hidedashboard}) {

    const {t, i18n } = useTranslation();
    const [option,setOption] = useState(1)
    const cookies = new Cookies(null ,{ path: '/' });
    const [walletEmpty,setWalletEmpty] = useState(true)
    const navigate = useNavigate();
    const location = useLocation();


    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    
    useEffect(()=>{
        topFunction()
        hidedashboard(true)
        nav("Accounting")
        // if(cookies.get("artistname").length!==0){
        //     setWalletEmpty(false)
        // }

        if(decodeToken(cookies.get("token")).info.artistName!==undefined){
            setWalletEmpty(false)
        }

    },[])

    useEffect(()=>{

    },[option])

    useEffect(()=>{
        if(location.pathname==="/dashboard/label/accounting/" || location.pathname==="/dashboard/label/accounting"){
            setOption(1)
          }
          if(location.pathname==="/dashboard/label/accounting/wallet"){
            setOption(2)
          }
      
          if(location.pathname==="/dashboard/label/accounting/statements"){
            setOption(3)
          }
    },[location.pathname])

   
    
    return (
        <div style={{height:'100vh',overflowY:'scroll'}}>
            {
                walletEmpty && 
                <div className="WalletEmptyContainer">
                                <img src={walletcomingsoon} style={{width:'20.91em',height:'100vh',marginTop:'5em'}}/>
                                <div className="NoAnalticsH1" style={{marginTop:'1em'}}>Wallet is Coming Soon...</div>   
                                <div className="NoAnalticsH2">The Wallet  is on its way! Soon, you'll be able to receive your royalties directly on N3RVE. Stay tuned for this exciting update!</div>   
                </div>
            }

            {
                !walletEmpty && 
                <div className="WalletContainer" style={{paddingBottom:'5em'}}>
                <div className="WalletHeaderTxt">
                 ACCOUNTING
                </div>

                <div style={{display:'flex',flexDirection:'row', borderBottom:'1px #595959 solid',marginLeft:'0em',width:'95.28%',marginTop:'2em'}}>
                    {
                       option !== 1 &&
                        <div>
                            <div className="MoneyDrawerHeading" onClick={()=>{setOption(1);navigate('/dashboard/label/accounting')}} style={{cursor:'pointer'}}>ROYALTIES</div>
                        </div>
                    }
    
                    {
                       option === 1 &&
                        <div>
                            <div className="MoneyDrawerHeadingSelected">ROYALTIES</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }
    
                    {
                       option !== 2 &&
                        <div>
                            <div className="MoneyDrawerHeading" onClick={()=>{setOption(2);navigate('/dashboard/label/accounting/wallet')}} style={{cursor:'pointer'}}>WALLET</div>
                        </div>
                    }
    
                    {
                       option === 2 &&
                        <div>
                            <div className="MoneyDrawerHeadingSelected">WALLET</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }
    
                    {
                       option !== 3 &&
                        <div>
                            <div className="MoneyDrawerHeading" onClick={()=>{setOption(3);navigate('/dashboard/label/accounting/statements')}} style={{cursor:'pointer'}}>STATEMENTS</div>
                        </div>
                    }
    
                    {
                       option === 3 &&
                        <div>
                            <div className="MoneyDrawerHeadingSelected">STATEMENTS</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }
    
                  
            
                </div>

                <div style={{width:'95.28%',marginTop:'1.5em'}}>
                    {/* {
                        option === 1 &&
                        <Routes>
                            <Route exact path="/" element={<Royalties nav={nav}/>}/>
                        </Routes>
                    }

                    {
                        option === 2 &&
                        <Routes>
                            <Route exact path="/wallet" element={<Wallet/>}/>
                         </Routes>
                    }

                    {
                        option === 3 &&
                        <Routes>
                            <Route exact path="/statements" element={<Statements/>}/>
                         </Routes>
                    } */}
                     <Routes>
                            <Route exact path="/" element={<Royalties nav={nav}/>}/>
                            <Route exact path="/wallet" element={<Wallet/>}/>
                            <Route exact path="/statements" element={<Statements/>}/>
                        </Routes>
                </div>
    
                {/* <div style={{display:'flex',flexDirection:'row',width:'95%',marginTop:'1.5em'}}>
                    <div className="WalletContainerLeft">
                        <div className="BalanceTxt">
                        {t('Balance')} 
                        </div>
    
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
    
                            {
                                cookies.get('lang') === 'en' &&
                                <div style={{display:'flex',flexDirection:'row',alignItems:'baseline'}} >
                                    <div className="AmountPrefix">
                                        $1,682
                                    </div>
                                    <div className="AmountSuffix">
                                        .55 USD
                                    </div>
                                </div>
                            }
    
                            {
                                cookies.get('lang') === 'jp' &&
                                <div style={{display:'flex',flexDirection:'row',alignItems:'baseline'}} >
                                    <div className="AmountPrefix">
                                        68500円
                                    </div>
                                </div>
                            }
                            
    
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <div className="SendReceiveContainer">
                                    <img src={sendicon} className="SendIcon"/>
                                    <div className="SendTxt">
                                    {t('Send')} 
                                    </div>
                                </div>
    
                                <div className="SendReceiveContainer">
                                    <img src={receiveicon} className="SendIcon"/>
                                    <div className="SendTxt">
                                    {t('Receive')} 
                                    </div>
                                </div>
    
                            
                                <img src={moreoptionsbtn} style={{width:'1.25em',height:'1.25em',cursor:'pointer'}}/>
                            </div>
    
                        </div>
                    </div>
    
                    <div className="WalletContainerRight">
                           <div>
                                <div className="BalanceTxt">
                                {t('Monthlyroyalty')} 
                                </div>
                                {
                                    cookies.get('lang') === 'en' &&
                                    <div style={{display:'flex',flexDirection:'row',alignItems:'baseline'}}>
                                        <div className="AmountPrefix">
                                            $483
                                        </div>
    
                                        <div className="AmountSuffix">
                                            .00 USD
                                        </div>
                                    </div>
                                }
    
                                {
                                    cookies.get('lang') === 'jp' &&
                                    <div style={{display:'flex',flexDirection:'row',alignItems:'baseline'}}>
                                        <div className="AmountPrefix">
                                        20300円
                                        </div>
                                    </div>
                                }
    
                           </div>
    
                           <img src={walletgraph} style={{width:'10.375em',height:'4.81em',marginLeft:'1.375em'}}/>
                    </div>
                </div> */}
    
               
                    {/* <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',width:'95%'}}>
                        <div className="BalanceTxt" style={{marginTop:'1em'}}>
                        {t('Latesttrans')} 
                        </div>
                        <img src={moreoptionsbtn} style={{width:'1.25em',height:'1.25em',cursor:'pointer'}}/>
                    </div> */}
    
                    {/* <div className="TransactionListItem">
                        <div style={{display:'flex',flexDirection:'row',width:'30%'}}>
                            <img src={receivepaymenticon} style={{width:'2em',height:'2em',marginRight:'1em'}}/>
    
                            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                                <div className="TransactionName">
                                {t('Royaltypayment')}
                                </div>
                                <div className="TransactionDate">
                                {t('Yesterday')}
                                </div>
                            </div>
    
                        </div>
    
                        <div className="TransactionType">
                        {t('Received')}
                        </div>
    
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
                        {
                                    cookies.get('lang') === 'en' &&
                            <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                $132.90
                            </div>
                        }
                        {
                                    cookies.get('lang') === 'jp' &&
                            <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                19378円
                            </div>
                        }
    
                            <img src={paymentinfoicon} style={{width:'0.6em',height:'0.85em',marginLeft:'1.7em'}}/>
    
                        </div>
    
                    </div> */}
    
                    {/* <div className="TransactionListItem">
                        <div style={{display:'flex',flexDirection:'row',width:'30%'}}>
                            <img src={banktransfericon} style={{width:'2em',height:'2em',marginRight:'1em'}}/>
    
                            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                                <div className="TransactionName">
                                {t('Banktransfer')} 
                                </div>
                                {
                                    cookies.get('lang') === 'en' &&
                                <div className="TransactionDate">
                                    August 10
                                </div>
                                }
                                {
                                    cookies.get('lang') === 'jp' &&
                                <div className="TransactionDate">
                                    8月10日
                                </div>
                                }
                            </div>
    
                        </div>
                    
                         <div className="TransactionType">
                                    {t('Deposited')} 
                        </div>
                       
    
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
                        {
                                    cookies.get('lang') === 'en' &&
                                <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                    $100.00
                                </div>
                        }
                        {
                                    cookies.get('lang') === 'jp' &&
                                <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                    14680円
                                </div>
                        }
                           
    
                            <img src={paymentinfoicon} style={{width:'0.6em',height:'0.85em',marginLeft:'1.7em'}}/>
    
                        </div>
    
                    </div> */}
    
                    {/* <div className="TransactionListItem">
                        <div style={{display:'flex',flexDirection:'row',width:'30%'}}>
                            <img src={receivepaymenticon} style={{width:'2em',height:'2em',marginRight:'1em'}}/>
    
                            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                                <div className="TransactionName">
                                {t('Royaltypayment')}
                                </div>
                                {
                                    cookies.get('lang') === 'en' &&
                                    <div className="TransactionDate">
                                    July 10
                                 </div>
                                }
                                {
                                    cookies.get('lang') === 'jp' &&
                                    <div className="TransactionDate">
                                    7月10日
                                 </div>
                                }
                                
                            </div>
    
                        </div>
    
                        <div className="TransactionType">
                        {t('Received')}
                        </div>
    
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
                        {
                                    cookies.get('lang') === 'en' &&
                                <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                    $350.20
                                </div>
                        }
                        {
                                    cookies.get('lang') === 'jp' &&
                                <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                    51381円
                                </div>
                        }
                           
    
                            <img src={paymentinfoicon} style={{width:'0.6em',height:'0.85em',marginLeft:'1.7em'}}/>
    
                        </div>
    
                    </div>
     */}
                    {/* <div className="TransactionListItem">
                        <div style={{display:'flex',flexDirection:'row',width:'30%'}}>
                            <img src={sendpaymenticon} style={{width:'2em',height:'2em',marginRight:'1em'}}/>
    
                            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                                <div className="TransactionName">
                                {t('Merchantpayment')} Beats Market
                                </div>
                                {
                                    cookies.get('lang') === 'en' &&
                                    <div className="TransactionDate">
                                    July 2
                                 </div>
                                }
                                {
                                    cookies.get('lang') === 'jp' &&
                                    <div className="TransactionDate">
                                   7月2日
                                 </div>
                                }
                                
                            </div>
    
                        </div>
    
                        <div className="TransactionType">
                        {t('Sent')}
                        </div>
    
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
                        {
                                    cookies.get('lang') === 'en' &&
                                <div className="TransactionAmount" style={{color:"#FF6363"}}>
                                    -$49.90
                                 </div>
                        }
                        {
                                    cookies.get('lang') === 'jp' &&
                                <div className="TransactionAmount" style={{color:"#FF6363"}}>
                                    -7325円
                                 </div>
                        }
                            
    
                            <img src={paymentinfoicon} style={{width:'0.6em',height:'0.85em',marginLeft:'1.7em'}}/>
    
                        </div>
    
                    </div> */}
    
                    {/* <div className="TransactionListItem">
                        <div style={{display:'flex',flexDirection:'row',width:'30%'}}>
                            <img src={receivepaymenticon} style={{width:'2em',height:'2em',marginRight:'1em'}}/>
    
                            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                                <div className="TransactionName">
                                {t('Royaltypayment')}
                                </div>
                                <div className="TransactionDate">
                                {
                                    cookies.get('lang') === 'en' &&
                                    <div className="TransactionDate">
                                     June 30
                                 </div>
                                }
                                {
                                    cookies.get('lang') === 'jp' &&
                                    <div className="TransactionDate">
                                   6月30日
                                 </div>
                                }
                                  
                                </div>
                            </div>
    
                        </div>
    
                        <div className="TransactionType">
                        {t('Received')}
                        </div>
    
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
                        {
                                    cookies.get('lang') === 'en' &&
                                <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                    $32.90
                                </div>
                        }
                        {
                                    cookies.get('lang') === 'jp' &&
                                <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                    4829円
                                </div>
                        }
                           
    
                            <img src={paymentinfoicon} style={{width:'0.6em',height:'0.85em',marginLeft:'1.7em'}}/>
    
                        </div>
    
                    </div> */}

    
    
            </div>
            }
        </div>
       
    );
}

export default Accounting;